export default __webpack_public_path__ + "static/media/Impervious Tasset.06bf48c4.jpg";